import { IChartOptions, IChartResult } from './chartSteps';

import {
	axisesAndLegends,
	IAxisesAndLegendsResult,
	tryApplyCustomColors,
	tryTranslateCaption
} from './chartSteps';
import { ApexOptions } from 'apexcharts';
import { ResultSet } from '@cubejs-client/core';
import { cloneDeep, isArray, isNil, merge } from 'lodash';

export default function radarChart(resultSet: ResultSet, options: IChartOptions, isGroupedByWeek: boolean, preloadedAxisNames: string[] | null = null): IChartResult {
	// IChartProps - IChartOptions
	let r = axisesAndLegends(resultSet, cloneDeep(options), isGroupedByWeek, preloadedAxisNames);
	r = tryApplyCustomColors(r);
	return toChartResult(r, options);
}

function toChartResult(result: IAxisesAndLegendsResult, options: IChartOptions): IChartResult {
	
	const internalConfig = !isNil(options.config) && isArray(options.config) ? options.config[0] : options.config; 
	
	const defaultOptions: ApexOptions = {
		chart: {
			type: 'radar',
		},
		legend: {
			formatter: seriesName => tryTranslateCaption(seriesName, options.translate)
		},
		xaxis: {
			categories: {
				formatter: value => tryTranslateCaption(value, options.translate)
			},
			labels: {
				formatter: value => tryTranslateCaption(value, options.translate)
			}
		},		
		tooltip: {
			y: {
				title: {
					formatter: val => tryTranslateCaption(val, options.translate)
				}
			}
		}
	};

	const mergedOptions = merge({}, result.output.chartResult.options, defaultOptions);
	const series = result.output.pivots.series;

	
	return {
		options: mergedOptions,
		series: series
	};
}
